<div class="efx-overlay" >
    <div class="efx-spinner"></div>
    <br/>
    <div class="efx-spinner-text-container">
        <span class="efx-spinner-text">
            Cargando...
        </span>
    </div>
</div>